import { useFeatureFlags } from 'utils/features';

export default function useBudgetPerformanceFeatureEnabled() {
  const localIsTurnedOn = useFeatureFlags('BUDGET_PERFORMANCE');
  const launchDarklyIsTurnedOn = useFeatureFlags('PERFORMANCE_SCORES');
  return localIsTurnedOn && launchDarklyIsTurnedOn;
}
